import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';
import { PagedResult } from '../models/paging';
import {
  AllocatedPriceSign,
  PriceSignDtoV2,
  Prices,
  PriceSignLocation,
  PriceSignPrice,
  PriceSignSearchEvent,
  UnallocatedPriceSign,
} from 'src/app/features/price-signs/price-sign.model';

@Injectable({
  providedIn: 'root',
})
export class PriceSignService {
  private httpClient = inject(HttpClient);

  private readonly apiUrl: string;
  private readonly apiUrlPriceSignService: string;

  constructor() {
    const environmentService = inject(EnvironmentLoaderService);

    this.apiUrl = <string>environmentService.config.serviceBaseUrl + '/api/v1/admin';
    this.apiUrlPriceSignService = <string>environmentService.config.serviceBaseUrl + '/api/v2/price-signs';
  }

  public getAllocatedPriceSigns(searchEvent: PriceSignSearchEvent): Observable<PagedResult<AllocatedPriceSign>> {
    const url = `${this.apiUrl}/price-signs/allocated/`;
    let params = new HttpParams();
    if (searchEvent?.query) {
      params = params.append('query', searchEvent.query);
    }
    if (searchEvent.paging?.pageIndex) {
      params = params.append('page', searchEvent.paging.pageIndex);
    }
    if (searchEvent.paging?.pageSize) {
      params = params.append('pageSize', searchEvent.paging.pageSize);
    }
    if (searchEvent.sorting?.active) {
      params = params.append('sortby', searchEvent.sorting?.active);
    }
    if (searchEvent.sorting?.direction) {
      params = params.append('sortdirection', searchEvent.sorting?.direction);
    }
    return this.httpClient.get<PagedResult<AllocatedPriceSign>>(url, {
      params,
    });
  }

  public getPriceSignLocations(query: string): Observable<PriceSignLocation[]> {
    const url = `${this.apiUrl}/price-signs/locations/`;
    let params = new HttpParams();
    if (query) {
      params = params.append('query', query);
    }
    return this.httpClient.get<PriceSignLocation[]>(url, {
      params,
    });
  }
  public getPriceSignPrices(vendorIdentifier: string): Observable<PriceSignDtoV2> {
    const url = `${this.apiUrlPriceSignService}/${encodeURIComponent(vendorIdentifier)}/prices`;
    return this.httpClient.get<PriceSignDtoV2>(url);
  }

  public getUnallocatedPriceSigns(): Observable<UnallocatedPriceSign[]> {
    const url = `${this.apiUrl}/price-signs/unallocated/`;
    return this.httpClient.get<UnallocatedPriceSign[]>(url);
  }

  public allocatePriceSign(priceSignIdentifier: string, chargingStationLocationIdentifier: string): Observable<string> {
    const url = `${this.apiUrl}/price-sign-allocation`;
    return this.httpClient.post<string>(url, {
      priceSignIdentifier,
      chargingStationLocationIdentifier,
    });
  }
  public editAllocatePriceSign(priceSignIdentifier: string, chargingStationLocationIdentifier: string): Observable<string> {
    const url = `${this.apiUrl}/price-sign-allocation/${priceSignIdentifier}`;
    return this.httpClient.put<string>(url, {
      chargingStationLocationIdentifier,
    });
  }

  public unallocatePriceSign(relationIdentifier: string): Observable<void> {
    const url = `${this.apiUrl}/price-sign-allocation/${relationIdentifier}`;
    return this.httpClient.delete<void>(url);
  }
}
